



































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import BusinessUpdateContactForm from './BusinessUpdateContactForm.vue';
import BusinessVerifyContactForm from './BusinessVerifyContactForm.vue';
import _ from 'lodash';

@Component({
  components: {
    BusinessUpdateContactForm,
    BusinessVerifyContactForm,
  },
  computed: {
    ...mapState('Business', {
      business: 'business',
    }),
  },
})
export default class BusinessUpdateContactList extends Vue {
  business!: Model;
  @Prop({ default: false }) addBillingContact!: boolean;
  @Prop({ default: false }) addPrimaryContact!: boolean;

  selectedContact = {
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    phone: '',
    position_title: '',
    is_billing: this.addBillingContact,
    is_primary: this.addPrimaryContact,
  };

  verifyContact: Model = {
    object_id: '',
  };
  verifyItem = 'email';
  showVerifyDialog = false;

  showSheet = false;

  headers = [
    {
      text: 'Name',
      value: 'first_name',
    },
    {
      text: 'Position Title',
      value: 'position_title',
    },
    {
      text: 'Email',
      value: 'email',
    },
    {
      text: 'Phone',
      value: 'mobile',
    },
    {
      text: ' ',
      value: 'is_primary',
      sortable: false,
    },
    {
      text: 'Actions',
      value: 'actions',
      sortable: false,
    },
  ];

  generateNewContact() {
    return {
      first_name: '',
      last_name: '',
      email: '',
      mobile: '',
      phone: '',
      position_title: '',
      is_billing: this.addBillingContact,
      is_primary: this.addPrimaryContact,
    };
  }

  addContact() {
    this.showSheet = true;
    this.selectedContact = this.generateNewContact();
  }

  editContact(contact) {
    this.showSheet = true;
    this.selectedContact = _.cloneDeep(contact);
  }

  deleteContact(contact) {
    this.$store.dispatch('BusinessContact/delete', contact);
  }

  setAsBilling(contact) {
    this.$store.dispatch('BusinessContact/billingContact', contact).then(() => {
      this.$store.dispatch('Business/fetch', {
        businessOid: this.business.object_id,
        config: {
          params: {
            expand: [
              'business_contacts',
              'business_addresses',
              'billing_address',
              'billing_contact',
              'postal_address',
              'primary_contact',
              'director_contact',
            ],
          },
        },
      });
    });
  }

  setAsPrimary(contact) {
    this.$store.dispatch('BusinessContact/primaryContact', contact).then(() => {
      this.$store.dispatch('Business/fetch', {
        businessOid: this.business.object_id,
        config: {
          params: {
            expand: [
              'business_contacts',
              'business_addresses',
              'billing_address',
              'billing_contact',
              'postal_address',
              'primary_contact',
              'director_contact',
            ],
          },
        },
      });
    });
  }

  setAsDirector(contact) {
    this.$store
      .dispatch('BusinessContact/directorContact', contact)
      .then(() => {
        this.$store.dispatch('Business/fetch', {
          businessOid: this.business.object_id,
          config: {
            params: {
              expand: [
                'business_contacts',
                'business_addresses',
                'billing_address',
                'billing_contact',
                'postal_address',
                'primary_contact',
                'director_contact',
              ],
            },
          },
        });
      });
  }

  rowStyle() {
    // if (
    //   this.business.billing_contact &&
    //   contact.object_id == this.business.billing_contact.object_id
    // ) {
    //   return "teal lighten-4"
    // }
    return '';
  }

  isEmpty(v) {
    return _.isEmpty(v);
  }

  verifyDialog(item, verifyItem = 'email') {
    this.verifyContact = _.cloneDeep(item);
    this.showVerifyDialog = true;
    this.verifyItem = verifyItem;
  }
}
